// $(document).ready(function() {
//   const $body = $('body');
//   const $html = $('html');
//   const $popup = $('.popup');
//   const $popupContent = $('#news-modal-content');
//
//   function openNewsModal(slug) {
//     $.request('newsModal::onOpenNewsModal', {
//       data: { slug: slug },
//       success: function (data) {
//         if (data['#news-modal-content']) {
//           $('#news-modal-content').html(data['#news-modal-content']);
//         }
//       }
//     }).done(function () {
//       $popup.addClass('modal-visible');
//       $popup.find('.popup-content').scrollTop(0);
//       $html.addClass('modal-open');
//     });
//   }
//
//   $body.on('click', '[data-open-modal="news"]', function (e) {
//     e.preventDefault();
//     const slug = $(this).data('slug');
//     console.log("slug", slug)
//     openNewsModal(slug);
//   });
//
//   $body.on('click', '[data-close-modal="news"]', function (e) {
//     e.preventDefault();
//     $popup.removeClass('modal-visible');
//     $html.removeClass('modal-open');
//     $popupContent.html('');
//   });
// });
